import moment from "moment";

export const tsToDate = ts => moment(ts * 1000).format('YYYY-MM-DD')
export const tsToDateTime = ts => moment(ts * 1000).format('YYYY-MM-DD HH:mm:ss')
